import NavBarComponent from "../../components/navBar/NavBarComponent";
import FooterComponent from "../../components/home/FooterComponent";
import ScrollableFeedComponent from "../../components/generalComponents/scrollableFeedComponent";


export default function BlogsHubPage() {

    return (
        <div>
            <NavBarComponent />
            <div className="bg-red-50">
                <ScrollableFeedComponent type="blogs" />
            </div>
            <FooterComponent />
        </div>
    )
}